import { makeStyles, Tab, Tabs } from "@material-ui/core";

import { COLORS } from "../../theme/colors";

const useStyles = makeStyles((theme) => ({
  tab: {
    textTransform: "none",
    fontSize: "1.14rem",
    fontWeight: 400,
    maxWidth: 500,
    marginRight: theme.spacing(3.5),
    minWidth: "fit-content",
  },
  tabSelected: {
    color: theme.palette.primary.main,
  },
  flexContainer: {
    borderBottom: `solid 4px ${COLORS.americanSilver}`,
  },
  indicator: {
    height: 4,
  },
}));

export const HorizontalTabs = ({
  tab,
  setTab,
  tabNames,
  additionalComponent,
  tabsStyle,
  variant,
  flexContainer,
  tabStyle,
}) => {
  const classes = useStyles();

  return (
    <Tabs
      value={tab}
      indicatorColor="primary"
      onChange={(event, newValue) => setTab(newValue)}
      style={tabsStyle}
      variant={variant}
      scrollButtons="off"
      classes={{
        flexContainer: flexContainer || classes.flexContainer,
        indicator: classes.indicator,
      }}
    >
      {tabNames.map((tabName, index) => (
        <Tab
          key={index}
          label={tabName}
          classes={{ root: classes.tab, selected: classes.tabSelected }}
          style={tabStyle}
        />
      ))}
      {additionalComponent}
    </Tabs>
  );
};
